import React from 'react';
import styled from 'styled-components';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
	heading: string;
}

const Container = styled.section``;

const Title = styled.h2`
	display: grid;
	grid-gap: 48px;
	grid-template-columns: 1fr auto 1fr;
	align-items:  center;
	width: 100%;
	${({ theme }) => theme.typography.heading6};
	margin: 0 0 48px;
	color: inherit;
	text-transform: uppercase;
	text-align: center;

	&:before,
	&:after {
		content: '';
		display: inline-block;
		width: 50%;
		height: 0;
		border: 1px solid #aaa;
	}

	&:before {
		justify-self: end;
	}

	&:after {
		justify-self: start;
	}
`;

export const SecondarySection = React.forwardRef<HTMLDivElement, Props>(({ heading: title, children, ...props }, ref) =>
	<Container {...props} ref={ref}>
		<header>
			<Title>{title}</Title>
		</header>
		<div>
			{children}
		</div>
	</Container>
);